export default __webpack_public_path__ + "static/media/FONDO_FRIJOL.50c1d241.jpg";